import React, { useEffect, useRef, useState } from "react";
import {
  FarmerSelectionItem,
  getFarmerSelection,
} from "Common/utils/farmerSelection";

interface FarmerIdentityInfoProps {
  farmerId: any;
  cropYearId?: any;
  className?: string;
}

const FarmerIdentityInfo = ({
  farmerId,
  cropYearId,
  className = "",
}: FarmerIdentityInfoProps) => {
  const [info, setInfo] = useState<FarmerSelectionItem | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const requestRef = useRef<number>(0);

  const year = cropYearId ?? localStorage.getItem("crop_year_id");

  useEffect(() => {
    setInfo(null);
    setMessage("");
    if (!farmerId || !year) return;

    // پاسخ درخواست قدیمی نباید روی انتخاب فعلی بنشیند
    const requestId = ++requestRef.current;
    setIsLoading(true);

    getFarmerSelection({ cropYearId: year, farmerId })
      .then((res) => {
        if (requestId !== requestRef.current) return;
        const item =
          res.items.find((row) => String(row.id) === String(farmerId)) ||
          res.items[0] ||
          null;
        setInfo(item);
        if (!item) setMessage("اطلاعات کشاورز انتخاب‌شده در دسترس نیست");
      })
      .catch(() => {
        if (requestId !== requestRef.current) return;
        setMessage("دریافت مشخصات کشاورز انجام نشد");
      })
      .finally(() => {
        if (requestId === requestRef.current) setIsLoading(false);
      });
  }, [farmerId, year]);

  if (!farmerId) return null;

  const commitments = (info?.commitment_numbers || []).map(String);

  return (
    <div
      className={`flex flex-col gap-1 p-2 rounded-md bg-slate-100 text-sm dark:bg-zink-600 dark:text-gray-100 ${className}`}
    >
      {isLoading ? (
        <span className="text-gray-500 dark:text-gray-300">
          در حال دریافت مشخصات کشاورز...
        </span>
      ) : message ? (
        <span className="text-red-500">{message}</span>
      ) : (
        <>
          <span className="font-medium">نام پدر: {info?.father_name || "-"}</span>
          <span className="font-medium">کد ملی: {info?.national_id || "-"}</span>
          <span className="font-medium">
            شماره قرارداد:{" "}
            {commitments.length ? commitments.join("، ") : "ثبت نشده"}
          </span>
        </>
      )}
    </div>
  );
};

export default FarmerIdentityInfo;
